import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import Image from "components/landing/image"
import { StyledUnderlineLink } from "components/landing/link"
import { getUrlProps } from "helpers/landing"

const Grid = styled(Box).attrs((props) => ({
  display: "grid",
  gap: { _: 4, desktop: 5 },
  gridAutoColumns: "1fr",
  gridAutoFlow: { _: "row", desktop: "column" },
  justifyContent: "center",
  px: { _: 2, tablet: 4, widescreen: "60px" },
  py: { _: 4, widescreen: "60px" },
  ...props,
}))``

const LandingImageRowItem = ({ element, lazyload }) => {
  const { title, cta, url, image, style } = element
  const urlProps = getUrlProps(url, element.anchor_name || element.id)

  return (
    <Box textAlign="center">
      <Box {...urlProps}>
        <Image image={image} lazyload={lazyload} />
      </Box>
      <Typography
        dangerouslySetInnerHTML={{
          __html: title,
        }}
        fontWeight="600"
        mt={2}
        variant="body-lg"
        {...style.title_style}
      />
      <StyledUnderlineLink
        aria-hidden
        fontSize="16px"
        fontWeight="500"
        lineHeight="16px"
        mt={1}
        tabIndex="-1"
        to={url}
        {...style.cta_style}
      >
        <Typography
          dangerouslySetInnerHTML={{
            __html: cta,
          }}
        />
      </StyledUnderlineLink>
    </Box>
  )
}

LandingImageRowItem.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

const LandingImageRow = ({ element, lazyload }) => {
  const {
    contain,
    data: { items },
    style,
  } = element

  return (
    <Box containWide={contain} {...style?.block_style}>
      <Grid {...style?.grid_style}>
        {items.map((item, i) => (
          <LandingImageRowItem
            element={item}
            key={`landing-image-row-item-${i}`}
            lazyload={lazyload}
          />
        ))}
      </Grid>
    </Box>
  )
}

LandingImageRow.propTypes = {
  element: PropTypes.object,
  lazyload: PropTypes.bool,
}

export default LandingImageRow
